import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col, Layout, Menu, Icon, Input, Modal, Form, message } from 'antd';
import Routes from "./Routes";
import Cookie from 'js-cookie';
import { loadReCaptcha } from 'react-recaptcha-google'
import "./App.css";
import vub from "./img/VUB-MONO.png";
// import normalmamca from "./img/MAMCA.png";
import mamca from "./img/MOBI-MAMCA.png";
const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;

//feedback modal
const FeedbackForm = Form.create({ name: 'form_in_modal' })(
  // eslint-disable-next-line
  class extends Component {
    render() {
      const {
        visible, onCancel, onCreate, form
      } = this.props; //read all the property send from Homepage

      const { TextArea } = Input;
      const { getFieldDecorator } = form; //can get the input value
      return (
        <Modal
          visible={visible} //control the showing of modal
          title="Feedback"
          okText="Send"
          onCancel={onCancel}
          onOk={onCreate}
        >
          <Form layout="vertical">
            <Form.Item label="Feed back">
              {getFieldDecorator('feedback', {
                rules: [{ required: true, message: 'Please leave your feedback!' }], //set the rule
              })(
                <TextArea />
              )}
            </Form.Item>
          </Form>
        </Modal>
      );
    }
  }
);

class App extends Component {


  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: Cookie.get("isAuthenticated") || false, //load cookie or false
      feedbackVisible: false, //for feedback modal
      collapsed: false, //state for the menu to collapse or not
      selectedKeys: [] //selected keys for the menu
    };

  }

  //show or cancel create modal
  showFeedbackModal = () => {
    this.setState({ feedbackVisible: true });
  }

  handleFeedbackCancel = () => {
    this.setState({ feedbackVisible: false });
  }


  //save all the form data of create
  saveFFormRef = (formRef) => {
    this.FformRef = formRef;
  }
  //create project
  handleFeedback = () => {
    const form = this.FformRef.props.form; //get all the data from modal
    form.validateFields((err, values) => { //can get values based on name
      if (err || values.feedback.trim().length === 0) { //trim the project name to check the length
        return;
      }
      else {
        fetch('/feedback/sendfeedback', { //REST create project
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: Cookie.get("email"),
            feedbackInfo: values.feedback
          }),
        }).then(res => res.json())
          .then(json => {
            if (json.success) {
              this.setState({ feedbackVisible: false }); //make modal invisible
              message.success(json.message); //create successfully, show mesage
              form.resetFields(); //reset the form
            }
            else {
              message.error(json.message); //create unsuccessfully, show alert
            }
          });
      }
    });
  }
  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  //function to set authentication
  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }

  //logout function
  handleLogout = event => {
    this.userHasAuthenticated(false);
    Cookie.remove('isAuthenticated'); //remove cookie
    Cookie.remove('email');
    this.props.history.push("/login"); //redirect to login
  }

  //survey no header
  surveyPage() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated, //send the information to child props
      userHasAuthenticated: this.userHasAuthenticated //send the function to child props
    };
    return (
      <div>
        {/* the child page is here */}
        <Routes childProps={childProps} />
      </div>
    );
  }

  //normal header for unauthenticated page
  userUnauthenticatedPage() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated, //send the information to child props
      userHasAuthenticated: this.userHasAuthenticated //send the function to child props
    };
    const onClick = ({ key, keyPath }) => {
      // Use the key here
      // If you want to use a specific key you have to do something like:
      if (key === "1") {
        this.props.history.push("/"); //redirect to homepage
        this.setState({ selectedKeys: ["1"] }) //set selected key
      }
      if (key === "5") {
        this.props.history.push("/login");
        this.setState({ selectedKeys: ["5"] })

      }
      if (key === "12") {
        this.props.history.push("/licenseinfo");
        this.setState({ selectedKeys: ["12"] })
      }
    }
    return (
      <div>
        <Header style={{ background: '#fff', padding: 0 }}>
          <Row type="flex" justify="space-between" align="middle">
            <Col>
              <div className="logo" style={{ cursor: "pointer" }} onClick={() => {
                this.props.history.push("/");
                this.setState({
                  selectedKeys: ["1"]
                })
              }}>
                <h1 style={{ color: "#4C6F74", marginLeft: "2vh", fontSize: "2em", textAlign: "center" }}>MAMCA<sup>&copy;</sup></h1>
              </div>
            </Col>
            <Col>
              <Menu
                theme="white"
                mode="horizontal"
                onClick={onClick}
                style={{ lineHeight: '64px' }}
                selectedKeys={this.state.selectedKeys}
              >

                <Menu.Item style={{ float: "right" }} key="5">Login</Menu.Item>
                {/* <Menu.Item style={{ float: "right" }} key="12">Request License</Menu.Item> */}

              </Menu>
            </Col>
          </Row>
        </Header>
        {/* the child page is here */}
        <Routes childProps={childProps} />
      </div>
    );
  }

  //menu for authenticated page
  userAuthenticatedPage() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated
    };

    const onClick = ({ key, keyPath }) => {
      // Use the key here
      // If you want to use a specific key you have to do something like:
      if (key === "1") {
        this.props.history.push("/homepage"); //redirect to homepage
        this.setState({ selectedKeys: ["1"] }) //set selected key
      }
      if (key === "2") {
        this.props.history.push("/profile");
        this.setState({ selectedKeys: ["2"] })
      }
      if (key === "3") {
        this.handleLogout();
        this.setState({ selectedKeys: ["5"] })
      }
      if (key === "4") {
        this.props.history.push("/guide");
        this.setState({ selectedKeys: ["4"] })
      }
      if (key === "6") {
        this.props.history.push("/result");
        this.setState({ selectedKeys: ["6"] })
      }
      if (key === "7") {
        this.props.history.push("/invitedprojects");
        this.setState({ selectedKeys: ["7"] })
      }
      if (key === "8") {
        this.props.history.push("/manageinvitations");
        this.setState({ selectedKeys: ["8"] })
      }
      if (key === "9") {
        this.props.history.push("/sharedprojects");
        this.setState({ selectedKeys: ["9"] })
      }
      if (key === "10") {
        this.props.history.push("/managesharedprojects");
        this.setState({ selectedKeys: ["10"] })
      }
      if (key === "11") {
        this.setState({
          feedbackVisible: true,
          selectedKeys: ["11"]
        })
      }

    }

    return (
      <Layout>
        <Sider
          trigger={null}
          collapsible
          collapsed={this.state.collapsed}
          style={{ boxShadow: "3px 0 3px 0px #ccc" }}
        >
          <div className="logo" style={{ cursor: "pointer" }} onClick={() => {
            this.props.history.push("/homepage");
            this.setState({
              selectedKeys: ["1"]
            })
          }}>
            <img src={mamca} style={{ marginLeft: "4px", width: "75px" }} alt="MAMCA" />
            {!this.state.collapsed ? <b style={{ color: "white", marginLeft: "1.5vh", textAlign: "center" }}>MAMCA</b> : <div></div>}
          </div>
          <Menu className="mamcaSideMenu" onClick={onClick} theme="dark" mode="inline" selectedKeys={this.state.selectedKeys} defaultSelectedKeys={['1']}>
            <Menu.Item key="1">
              <Icon type="project" />
              <span>Homepage</span>
            </Menu.Item>
            {/* <Menu.Item key="6">
              <Icon type="bar-chart" />
              <span>Result</span>
            </Menu.Item> */}
            <Menu.Item key="7">
              <Icon type="robot" />
              <span>Invited Projects</span>
            </Menu.Item>
            <Menu.Item key="8">
              <Icon type="diff" />
              <span>Manage Invitations</span>
            </Menu.Item>
            {/* <Menu.Item key="9">
              <Icon type="share-alt" />
              <span>Shared Projects</span>
            </Menu.Item>
            <Menu.Item key="10">
              <Icon type="usergroup-add" />
              <span>Manage Share</span>
            </Menu.Item> */}
            <Menu.Item key="2">
              <Icon type="user" />
              <span>Profile</span>
            </Menu.Item>
            <Menu.Item key="3">
              <Icon type="logout" />
              <span>Logout</span>
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout>
          <Header style={{ background: '#fff', padding: 0 }}>
            <Row type="flex" justify="space-between" align="middle">
              <Col>
                <Icon
                  className="headerTrigger"
                  type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                  onClick={this.toggle}
                />
              </Col>
              <Col>
                <Menu
                  theme="white"
                  mode="horizontal"
                  onClick={onClick}
                  style={{ lineHeight: '64px' }}
                  selectedKeys={this.state.selectedKeys}
                >

                  <SubMenu style={{ float: "right" }} key="sub1" title={<span><Icon type="user" />{Cookie.get("email")}</span>}>
                    <Menu.Item key="2">Profile</Menu.Item>
                    <Menu.Item key="3">Logout</Menu.Item>
                  </SubMenu>
                  <Menu.Item style={{ float: "right" }} key="4">Guide</Menu.Item>
                  {/* <Menu.Item style={{ float: "right" }} key="11">Feedback</Menu.Item> */}
                  {/* <Menu.Item style={{ float: "right" }} key="12">License</Menu.Item> */}
                </Menu>
              </Col>
            </Row>
          </Header>
          <Content style={{
            margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280,
          }}
          >
            {/* the child page is here */}
            <Routes childProps={childProps} />
          </Content>
        </Layout>
      </Layout>
    );
  }
  componentDidMount() {  //must set the state here otherwise the information will disapear after refresh
    loadReCaptcha(); //google ReCaptcha
    if (this.props.location.pathname === "/") {
      this.setState({ selectedKeys: ["1"] })
    }
    if (this.props.location.pathname === "/homepage") {
      this.setState({ selectedKeys: ["1"] })
    }
    if (this.props.location.pathname === "/profile") {
      this.setState({ selectedKeys: ["2"] })
    }
    if (this.props.location.pathname === "/guide") {
      this.setState({ selectedKeys: ["4"] })
    }
    if (this.props.location.pathname === "/login") {
      this.setState({ selectedKeys: ["5"] })
    }
    if (this.props.location.pathname === "/result") {
      this.setState({ selectedKeys: ["6"] })
    }
    if (this.props.location.pathname === "/invitedprojects") {
      this.setState({ selectedKeys: ["7"] })
    }
    if (this.props.location.pathname === "/manageinvitations") {
      this.setState({ selectedKeys: ["8"] })
    }
    if (this.props.location.pathname === "/sharedprojects") {
      this.setState({ selectedKeys: ["9"] })
    }
    if (this.props.location.pathname === "/managesharedprojects") {
      this.setState({ selectedKeys: ["10"] })
    }
    if (this.props.location.pathname === "/licenseinfo") {
      this.setState({ selectedKeys: ["12"] })
    }
    if (this.props.location.pathname === "/signup") {
      this.setState({ selectedKeys: [] })
    }
  }
  render() {
    let thisYearDate = new Date().getFullYear();
    let currentURL = window.location.href;
    let isSurvey = false
    if (currentURL.includes('mamcaweightsurvey')||currentURL.includes('mamcaevaluationsurvey')) {
      isSurvey = true
    }
    return (
      <div>
        {/* if authenticated show the menu, other wise show the normal header */}
        {isSurvey ? this.surveyPage() :
          this.state.isAuthenticated ? this.userAuthenticatedPage() : this.userUnauthenticatedPage()}
        <FeedbackForm
          wrappedComponentRef={this.saveFFormRef}
          visible={this.state.feedbackVisible}
          onCancel={this.handleFeedbackCancel}
          onCreate={this.handleFeedback}
        />
        {/* footer is the same */}
        <div className="Mamca-footer">
          <Row type="flex" justify="space-around" align="middle">
            <Col span={8}>
              <a href="https://mobilise.research.vub.be/" target="_blank">
                <img src={vub} style={{ width: "50%", marginTop: "5vh" }} alt="VUB" />
              </a>
            </Col>
            <Col span={10}>
              <div style={{ marginTop: "5vh", fontSize: "1em" }}>
                <p>MOBILISE - Analysing mobility, mobilising people.</p>
              </div>
            </Col>
          </Row>
          <Row type="flex" justify="center" style={{ marginTop: "5vh" }}>
            <Col span={8}>
              <p>Copyright © {thisYearDate}. All rights reserved Vrije Universiteit Brussel</p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
export default withRouter(App);